<template>
    <div class="bottom-hero">
        <div class="hero-search__options d-flex flex-row gap-2 align-items-center pb-3 mb-2">
            <strong class="btn ms-auto" :class="{ 'active': activeTabIndex === 0 }" @click.prevent="activeTabIndex = 0">To rent</strong>
            <strong class="btn" :class="{ 'active': activeTabIndex === 1 }" @click.prevent="activeTabIndex = 1">Instant Valuation</strong>
            <strong class="btn me-auto" :class="{ 'active': activeTabIndex === 2 }" @click.prevent="activeTabIndex = 2">Agent valuation</strong>
        </div>
        <div class="d-flex gap-2 align-items-center me-auto mb-2">
            <strong>
                Enter {{ activeTabIndex === 0 ? 'Location' : 'Postcode' }}
            </strong>
            <Loader v-show="activeTabIndex > 0 && isLoading" />
        </div>
        <div class="hero-search__main">
            <SelectArea
                v-show="activeTabIndex === 0"
                has-search-button
                :is-rent-selected="adCategorySelected && adCategorySelected.is_rent"
                scrollFocusOnSearch
                :activeTabIndex="activeTabIndex"
            />
            <div class="position-relative w-100" v-show="activeTabIndex > 0">
                <input
                    type="text"
                    class="form-control mb-3 mb-lg-0"
                    placeholder="Enter postcode"
                    v-model="postcode"
                    name="postcode"
                    v-validate="{ required: activeTabIndex > 0 }"
                    >
                <button class="btn btn--secondary" type="button" @click.prevent="onValuationStart"
                    :disabled="postcode.length === 0">
                    Search
                </button>
            </div>
        </div>
        <span v-show="activeTabIndex > 0" class="form-error">{{ errors.first('postcode') }}</span>
    </div>
</template>

<script>
import Loader from '@components/partials/icons/Loader.vue';
import SelectArea from '@components/partials/select/SelectArea.vue';
import { push422ErrorsToValidator } from '@helpers/helpers';
import { redirectTo } from '@helpers/url-handler';

export default {
    inject: ['$validator'],
    components: {
        SelectArea,
        Loader,
    },
    props: {
        adCategories: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            adCategorySelected: null,
            activeTabIndex: 0,
            postcode: '',
            isLoading: false,
        };
    },
    computed: {
        redirectUrl() {
            let valuationType = 'instant';
            if (this.activeTabIndex === 2) valuationType = 'agent';

            return `/valuation/${this.postcode}?type=${valuationType}`;
        },
    },
    created() {
        this.adCategorySelected = this.adCategories.find((adCategory) => adCategory.is_rent);
    },
    methods: {
        redirectTo,
        onValuationStart() {
            this.isLoading = true;
            this.axios.post('/api/area/postcode/validate', { postcode: this.postcode })
                .then(() => {
                    this.redirectTo(this.redirectUrl);
                })
                .catch((error) => {
                    push422ErrorsToValidator(error, this.$validator);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>
